import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'kendo-dialog-alert',
  template: `<kendo-dialog
  *ngIf="data"
  title="{{ data.title }}"
  (close)="closing.emit(data)"
  [width]="450"
>
  <div class="example">

    <span [innerHTML]="data.message"></span>
    <br /><br />

    <kendo-dialog-actions [layout]="'end'">
      <div class="k-form-buttons">
        <button kendoButton themeColor="primary" (click)="closing.emit(data)">
          {{ data.btnText }}
        </button>
      </div>
    </kendo-dialog-actions>

  </div>
</kendo-dialog>`
})
export class KendoDialogAlertComponent {

  @Output() closing: EventEmitter<any> = new EventEmitter<any>();


  public data: any;


  @Input() set model(value: any) {
    if (!value) {
      return;
    }

    this.data = {
      title: value.title ?? 'Увага',
      message: value.message ?? '',
      btnText: value.btnText ?? 'Ok',
    };
  }

}
